import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { OffClickModule } from '@df/module-off-click/off-click.module';
import { NgInject } from '@df/ng/ng-inject';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { ToggleModule } from '@df/ui/toggle/toggle.module';
import { ToggleService } from '@df/ui/toggle/toggle.service';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { MEGANAV_GROUP_ID } from '../page/header/page-header.component';
import { IMenuItem } from '../page/header/page-header.interface';

/**
 * Meganav component.
 *
 * @usage
 * ```html
 * <meganav items="content.meganav"></meganav>
 * ```
 */
@Component({
    selector: 'meganav',
    templateUrl: 'meganav.html',
    styleUrls: ['./meganav.scss'],
    standalone: true,
    imports: [OffClickModule, ToggleModule, HrefComponent, SizeClassDirective, NgClass, ICmsClientModule],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MeganavComponent extends UiComponent {
    @Input()
    items!: IMenuItem[];
    /**
     * Async change detection
     */
    protected override asyncCd = false;

    @NgInject(ToggleService)
    readonly toggleService!: ToggleService;

    readonly meganavToggleGroupId = MEGANAV_GROUP_ID;

    get isCms(): boolean {
        return this.client.isCms && !this.client.isCmsPreview;
    }

    handleMouseEnter(index: number): void {
        if (!this.isCms) {
            this.toggleService.open([this.meganavToggleGroupId, index]);
        }
    }

    handleClick(index: number): void {
        if (this.isCms) {
            this.toggleService.toggle([this.meganavToggleGroupId, index]);
        }
    }

    close() {
        this.toggleService.closeGroup(this.meganavToggleGroupId, { exceptionItems: ['search'] });
    }
}
